import ProfileEmptyState from "@apps/profile/profile-empty-state";

const ProfileWorkHistorySidebarEmptyState = () => (
  <ProfileEmptyState>
    No work history summary available. Please check back later.
  </ProfileEmptyState>
);

export default ProfileWorkHistorySidebarEmptyState;
